import { GetterTree } from 'vuex'
import { BlogState } from '@/modules/blog/store'
import { RootState } from '@/store/types'
import { PostTranslation } from '@/modules/blog/types'

const getters: GetterTree<BlogState, RootState> = {

    /**
     * Obtiene una traducción de la publicación actualmente en edición
     */
    editingPostTranslation: (state) => (locale: string) => {
        return state.editingPost.translations.find(t => t.locale === locale)
    },

    /**
     * Obtiene la traducción seleccionada de la publicación en edición
     */
    currentEditingPostTranslation: (state): PostTranslation => {
        const post = state.editingPost
        const prototype = new PostTranslation('')

        // Si no existe ningún artículo en edición se retorna una traducción vacía
        if (!post || !post.translations) {
            return prototype
        }

        return post.translations.find(t => t.locale.toString() === state.currentTranslation) || prototype
    },
}

export default getters
